var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgShareFacebookLionDark = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 1240 1240"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#Share_Facebook_Lion_Dark_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#F7F9FA",
  d: "M0 0h1240v1240H0z"
}), /*#__PURE__*/React.createElement("rect", {
  width: 1240,
  height: 1240,
  fill: "#12192B",
  rx: 4
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFE591",
  d: "M867 1194.43c-132.8-8.97-187.167 130.48-193 187.57h576V435c-88.33 25.484-272.8 111.52-304 251.786-39 175.332 128.5 145.261 160 279.818s-73 239.046-239 227.826",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  fill: "#1199FA",
  fillOpacity: 0.08,
  d: "M35.51 263.741c-46.674-34.899-75.295-75.514-40.162-122.5 35.132-46.985 97.087-50.95 143.76-16.051s99.071 97.081 63.938 144.067-120.863 29.382-167.536-5.516"
}), /*#__PURE__*/React.createElement("g", {
  filter: "url(#Share_Facebook_Lion_Dark_svg__b)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 923,
  height: 1042,
  x: 160,
  fill: "#002F61",
  rx: 4
}), /*#__PURE__*/React.createElement("rect", {
  width: 923,
  height: 1042,
  x: 160,
  fill: "url(#Share_Facebook_Lion_Dark_svg__c)",
  fillOpacity: 0.3,
  rx: 4
})), /*#__PURE__*/React.createElement("rect", {
  width: 523,
  height: 530,
  x: 454,
  y: 399,
  fill: "#1199FA",
  fillOpacity: 0.15,
  rx: 4
}), /*#__PURE__*/React.createElement("path", {
  fill: "#1199FA",
  fillOpacity: 0.1,
  d: "M974.713 1195.46c-10.343 14.64-22.619 23.75-37.458 13.27-14.838-10.49-16.641-29.55-6.298-44.19 10.342-14.63 29.058-31.23 43.897-20.75 14.838 10.49 10.202 37.04-.141 51.67"
}), /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd",
  clipPath: "url(#Share_Facebook_Lion_Dark_svg__d)",
  clipRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M553.748 1147.82c-5.994 0-10.424-4.68-10.424-10.44 0-5.75 4.43-10.55 10.461-10.55 3.82 0 6.187 1.41 8.058 3.47l-2.863 3.08c-1.414-1.48-2.903-2.51-5.232-2.51-3.361 0-5.805 2.89-5.805 6.44 0 3.61 2.483 6.51 6.033 6.51 2.178 0 3.781-1.03 5.232-2.51l2.787 2.74c-1.984 2.21-4.314 3.77-8.247 3.77m17.016 0h-4.619v-20.95h4.619v4.91c1.259-3.01 3.589-5.07 7.14-4.91v4.87h-.268c-4.046 0-6.872 2.63-6.872 7.97zm31.325-20.99-10.209 26.63h-4.684l2.231-5.63-8.747-21h4.925l5.968 15.51 5.73-15.51zm13.629 4c-3.131 0-5.88 2.55-5.88 6.48 0 3.92 2.749 6.47 5.88 6.47 3.17 0 5.765-2.47 5.765-6.47 0-3.97-2.634-6.48-5.765-6.48m1.069 16.95c-3.321 0-5.422-1.67-6.836-3.54v9.22h-4.619v-26.63h4.619v3.77c1.49-2.1 3.591-3.77 6.836-3.77 4.773 0 9.393 3.77 9.393 10.48 0 6.7-4.581 10.47-9.393 10.47m19.522-16.57v9.86c0 1.79.911 2.52 2.481 2.52h1.812v4.11h-3.16c-3.362-.01-5.752-1.5-5.752-5.9v-10.59h-2.565v-3.96h2.565v-5.52h4.619v5.52h4.293v3.96zm18.907-.34c-3.705 0-6.072 2.89-6.072 6.44 0 3.58 2.559 6.51 6.148 6.51 3.74 0 6.109-2.89 6.109-6.44 0-3.58-2.558-6.51-6.185-6.51m0 16.95c-6.148 0-10.693-4.68-10.693-10.44 0-5.79 4.582-10.55 10.769-10.55 6.185 0 10.73 4.68 10.73 10.48 0 5.75-4.584 10.51-10.806 10.51m19.262-4.23v2.33c0 .09-.048.18-.134.23l-2.016 1.16a.26.26 0 0 1-.267 0l-2.02-1.16a.28.28 0 0 1-.135-.23v-2.33c0-.09.054-.18.135-.23l2.02-1.16a.26.26 0 0 1 .267 0l2.016 1.16c.086.05.134.14.134.23m35.716-12.72c-3.704 0-6.071 2.89-6.071 6.44 0 3.58 2.558 6.51 6.148 6.51 3.74 0 6.107-2.89 6.107-6.44 0-3.58-2.557-6.51-6.184-6.51m0 16.95c-6.148 0-10.692-4.68-10.692-10.44 0-5.79 4.582-10.55 10.769-10.55 6.185 0 10.729 4.68 10.729 10.48 0 5.75-4.583 10.51-10.806 10.51m-21.649-.02c-5.994-.12-10.332-4.89-10.221-10.64s4.631-10.47 10.662-10.35c3.818.07 6.158 1.53 7.99 3.62l-2.923 3.03c-1.383-1.51-2.852-2.57-5.182-2.61-3.359-.07-5.859 2.78-5.928 6.32-.069 3.62 2.358 6.56 5.907 6.63 2.177.04 3.8-.96 5.279-2.41l2.735 2.79c-2.027 2.17-4.386 3.69-8.319 3.62m59.916-20.97c4.392 0 7.064 2.78 7.064 7.69v13.3h-4.619v-11.89c0-3.2-1.49-4.91-4.085-4.91-2.52 0-4.316 1.75-4.316 4.99v11.81h-4.619v-11.92c0-3.13-1.529-4.88-4.088-4.88-2.557 0-4.314 1.91-4.314 5.03v11.77h-4.621v-20.99h4.621v3.47c1.299-1.79 3.056-3.47 6.148-3.47 2.902 0 4.925 1.41 5.994 3.54 1.644-2.13 3.781-3.54 6.835-3.54"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FEFEFE",
  d: "M483 1122.71v26.19l22.616 13.1 22.61-13.1v-26.19l-22.61-13.09zm1.991 25.04v-23.88l20.625-11.95 20.626 11.95v23.88l-20.626 11.95z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FEFEFE",
  d: "M514.478 1120.92h-17.77l-2.06 9.09h21.972zm-14.617 21.6v-6.04l-5.264-3.36-5.956 4.44 8.119 14.17h3.244l3.836-3.59v-1.8z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FEFEFE",
  d: "M511.388 1131.38h-11.507l1.938 5.08-.59 5.69h4.385l4.428-.02-.552-5.67z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FEFEFE",
  d: "m516.651 1133.08-5.203 3.4v6.04l-3.977 3.82v1.8l3.834 3.55h3.203l8.08-14.13z"
})), /*#__PURE__*/React.createElement("g", {
  fill: "#FFD348",
  opacity: 0.06
}, /*#__PURE__*/React.createElement("circle", {
  cx: 68.66,
  cy: 924.445,
  r: 15.445
}), /*#__PURE__*/React.createElement("circle", {
  cx: 68.66,
  cy: 986,
  r: 15.445
}), /*#__PURE__*/React.createElement("circle", {
  cx: 68.66,
  cy: 1047.55,
  r: 15.445
}), /*#__PURE__*/React.createElement("circle", {
  cx: 191.769,
  cy: 924.445,
  r: 15.445
}), /*#__PURE__*/React.createElement("circle", {
  cx: 191.769,
  cy: 986,
  r: 15.445
}), /*#__PURE__*/React.createElement("circle", {
  cx: 191.769,
  cy: 1047.55,
  r: 15.445
}), /*#__PURE__*/React.createElement("circle", {
  cx: 130.215,
  cy: 924.445,
  r: 15.445
}), /*#__PURE__*/React.createElement("circle", {
  cx: 130.215,
  cy: 986,
  r: 15.445
}), /*#__PURE__*/React.createElement("circle", {
  cx: 130.215,
  cy: 1047.55,
  r: 15.445
}), /*#__PURE__*/React.createElement("circle", {
  cx: 7.107,
  cy: 924.445,
  r: 15.445
}), /*#__PURE__*/React.createElement("circle", {
  cx: 7.107,
  cy: 986,
  r: 15.445
}), /*#__PURE__*/React.createElement("circle", {
  cx: 7.107,
  cy: 1047.55,
  r: 15.445
}), /*#__PURE__*/React.createElement("circle", {
  cx: 253.322,
  cy: 924.445,
  r: 15.445
}), /*#__PURE__*/React.createElement("circle", {
  cx: 253.322,
  cy: 986,
  r: 15.445
}), /*#__PURE__*/React.createElement("circle", {
  cx: 253.322,
  cy: 1047.55,
  r: 15.445
})), /*#__PURE__*/React.createElement("circle", {
  cx: 984.067,
  cy: 2.067,
  r: 9.067,
  fill: "#1199FA",
  fillOpacity: 0.1
}), /*#__PURE__*/React.createElement("circle", {
  cx: 984.067,
  cy: 38.2,
  r: 9.067,
  fill: "#1199FA",
  fillOpacity: 0.1
}), /*#__PURE__*/React.createElement("circle", {
  cx: 984.067,
  cy: 74.334,
  r: 9.067,
  fill: "#1199FA",
  fillOpacity: 0.1
}), /*#__PURE__*/React.createElement("circle", {
  cx: 1128.6,
  cy: 2.067,
  r: 9.067,
  fill: "#1199FA",
  fillOpacity: 0.1
}), /*#__PURE__*/React.createElement("circle", {
  cx: 1128.6,
  cy: 38.2,
  r: 9.067,
  fill: "#1199FA",
  fillOpacity: 0.1
}), /*#__PURE__*/React.createElement("circle", {
  cx: 1128.6,
  cy: 74.334,
  r: 9.067,
  fill: "#1199FA",
  fillOpacity: 0.1
}), /*#__PURE__*/React.createElement("circle", {
  cx: 1056.33,
  cy: 2.067,
  r: 9.067,
  fill: "#1199FA",
  fillOpacity: 0.1
}), /*#__PURE__*/React.createElement("circle", {
  cx: 1056.33,
  cy: 38.2,
  r: 9.067,
  fill: "#1199FA",
  fillOpacity: 0.1
}), /*#__PURE__*/React.createElement("circle", {
  cx: 1056.33,
  cy: 74.334,
  r: 9.067,
  fill: "#1199FA",
  fillOpacity: 0.1
}), /*#__PURE__*/React.createElement("circle", {
  cx: 1200.87,
  cy: 2.067,
  r: 9.067,
  fill: "#1199FA",
  fillOpacity: 0.1
}), /*#__PURE__*/React.createElement("circle", {
  cx: 1200.87,
  cy: 38.2,
  r: 9.067,
  fill: "#1199FA",
  fillOpacity: 0.1
}), /*#__PURE__*/React.createElement("circle", {
  cx: 1200.87,
  cy: 74.334,
  r: 9.067,
  fill: "#1199FA",
  fillOpacity: 0.1
}), /*#__PURE__*/React.createElement("circle", {
  cx: 1020.2,
  cy: 2.067,
  r: 9.067,
  fill: "#1199FA",
  fillOpacity: 0.1
}), /*#__PURE__*/React.createElement("circle", {
  cx: 1020.2,
  cy: 38.2,
  r: 9.067,
  fill: "#1199FA",
  fillOpacity: 0.1
}), /*#__PURE__*/React.createElement("circle", {
  cx: 1020.2,
  cy: 74.334,
  r: 9.067,
  fill: "#1199FA",
  fillOpacity: 0.1
}), /*#__PURE__*/React.createElement("circle", {
  cx: 1164.73,
  cy: 2.067,
  r: 9.067,
  fill: "#1199FA",
  fillOpacity: 0.1
}), /*#__PURE__*/React.createElement("circle", {
  cx: 1164.73,
  cy: 38.2,
  r: 9.067,
  fill: "#1199FA",
  fillOpacity: 0.1
}), /*#__PURE__*/React.createElement("circle", {
  cx: 1164.73,
  cy: 74.334,
  r: 9.067,
  fill: "#1199FA",
  fillOpacity: 0.1
}), /*#__PURE__*/React.createElement("circle", {
  cx: 1092.47,
  cy: 2.067,
  r: 9.067,
  fill: "#1199FA",
  fillOpacity: 0.1
}), /*#__PURE__*/React.createElement("circle", {
  cx: 1092.47,
  cy: 38.2,
  r: 9.067,
  fill: "#1199FA",
  fillOpacity: 0.1
}), /*#__PURE__*/React.createElement("circle", {
  cx: 1092.47,
  cy: 74.334,
  r: 9.067,
  fill: "#1199FA",
  fillOpacity: 0.1
}), /*#__PURE__*/React.createElement("circle", {
  cx: 1237,
  cy: 2.067,
  r: 9.067,
  fill: "#1199FA",
  fillOpacity: 0.1
}), /*#__PURE__*/React.createElement("circle", {
  cx: 1237,
  cy: 38.2,
  r: 9.067,
  fill: "#1199FA",
  fillOpacity: 0.1
}), /*#__PURE__*/React.createElement("circle", {
  cx: 1237,
  cy: 74.334,
  r: 9.067,
  fill: "#1199FA",
  fillOpacity: 0.1
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "Share_Facebook_Lion_Dark_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h1240v1240H0z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "Share_Facebook_Lion_Dark_svg__d"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M483 1108h274v55H483z"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "Share_Facebook_Lion_Dark_svg__c",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "rotate(53.047 -25.89 696.833)scale(1083.34 798.922)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("filter", {
  id: "Share_Facebook_Lion_Dark_svg__b",
  width: 963,
  height: 1082,
  x: 140,
  y: -16,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 4
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 10
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_1445_138150"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_1445_138150",
  result: "shape"
})))));
export default SvgShareFacebookLionDark;